module.exports = __webpack_public_path__ + "static/img/img16.5d2bb75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img16.png
// module id = pP0u
// module chunks = 1